import { render, staticRenderFns } from "./TeamPanel.vue?vue&type=template&id=5d5be0e1&"
import script from "./TeamPanel.vue?vue&type=script&lang=js&"
export * from "./TeamPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports